import { useRef, useState } from 'react';
import { reportEvent } from '@/app/utils';

export const useVideoState = () => {
  const [loadState, setLoadState] = useState<'loading' | 'error' | 'success'>('loading');
  const tipOpenTime = useRef<number>(0);

  const handleOpenChange = (open: boolean) => {
    if (open) {
      tipOpenTime.current = Date.now();
    } else {
      reportEvent('ref2video_video_exposure', {
        exposure_time: Date.now() - tipOpenTime.current,
      });
    }
  };

  return {
    videoLoadState: loadState,
    setVideoLoadState: setLoadState,
    handleVideoOpenChange: handleOpenChange,
  };
};
